/**
 * @(#)2019/7/15.
 * YxSwitch，可以开关操作
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxSwitch, { defaultProps } from "./yxSwitch";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import PropTypes from "prop-types";
YxSwitch.propTypes = {
  ...IYxInputPropTypes,

  //非选中时的显示文字
  unCheckedChildren: PropTypes.node,

  //选中时的显示文字
  checkedChildren: PropTypes.node,

  defaultChecked: PropTypes.bool,

  checked: PropTypes.bool,
};

//默认值
YxSwitch.defaultProps = defaultProps();

export default YxSwitch;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxSwitch/index.js